/* jshint esversion: 6 */
import React, { useState, useEffect} from 'react';

const TagInput = (props) => {
    const [ tags, setTags ] = useState([]);

    useEffect(() => {
        if (props.tags !== undefined && props.tags.length) {
            setTags(props.tags);
        }

        // set up copy/paste function here
    }, []);

    const onKeyUp = (e) => {
        let nextTags = [...tags];
        if (e.keyCode === 13) {
            nextTags.push(e.currentTarget.value.trim());
            e.currentTarget.value = "";
            updateTags(nextTags);
        }
    }

    const updateTags = (nextTags) => {
        setTags(nextTags);
        props.updateTags(nextTags);
    }

    const onPaste = (e) => {
        e.preventDefault();
        e.stopPropagation();

        let data = '';

        if ((data = e.clipboardData.getData('text/plain')) !== '') {
            let nextTags = data.split(/,\s?/g);
            if (tags.length) {
                nextTags = tags.concat(nextTags);
            }
            updateTags(nextTags);
        }

    }

    return (
        <div className="tag-input">
            <div className="pt-field-label">Tags</div>
            <div className={(props.hasTagError) ? 'tag-input-wrapper error' : 'tag-input-wrapper'}>
                {tags.length ? (
                     <ul className="tag-list">
                     {tags.map((tag, i) => {
                         return (
                             <li key={i}>
                                 {tag} <div className="remove-tag-button" role="button" aria-label="" onClick={() => {
                                    let nextTags = tags.toSpliced(i, 1);
                                    updateTags(nextTags);
                                 }}>
                                     <i className="icon ion-ios-close-outline"/>
                                 </div>
                             </li>
                         );
                     })}
                     </ul>
                ) : null}
                <input type="text" onKeyUp={onKeyUp} onPaste={onPaste}/>
            </div>
            <p className="instructions">Type in a tag and press 'enter' or 'return' to set it.</p>
        </div>
    );
};

export default TagInput;
